module.exports = __webpack_public_path__ + "02_mole.2e92d6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/02_mole.png
// module id = Z4a5
// module chunks = 0